export const Facebook = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.3333 10.85V14.2333H19.3667C19.6 14.2333 19.7167 14.4667 19.7167 14.7L19.25 16.9167C19.25 17.0333 19.0167 17.15 18.9 17.15H16.3333V25.6667H12.8333V17.2667H10.85C10.6167 17.2667 10.5 17.15 10.5 16.9167V14.7C10.5 14.4667 10.6167 14.35 10.85 14.35H12.8333V10.5C12.8333 8.51667 14.35 7 16.3333 7H19.4833C19.7167 7 19.8333 7.11667 19.8333 7.35V10.15C19.8333 10.3833 19.7167 10.5 19.4833 10.5H16.6833C16.45 10.5 16.3333 10.6167 16.3333 10.85Z"
        stroke="white"
        strokeWidth="1.3125"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M17.4997 25.6673H10.4997C4.66634 25.6673 2.33301 23.334 2.33301 17.5007V10.5007C2.33301 4.66732 4.66634 2.33398 10.4997 2.33398H17.4997C23.333 2.33398 25.6663 4.66732 25.6663 10.5007V17.5007C25.6663 23.334 23.333 25.6673 17.4997 25.6673Z"
        stroke="white"
        strokeWidth="1.3125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
